import { render } from "./ProjectOverview.vue?vue&type=template&id=ff0005ee&scoped=true&ts=true"
import script from "./ProjectOverview.vue?vue&type=script&lang=ts"
export * from "./ProjectOverview.vue?vue&type=script&lang=ts"

import "./ProjectOverview.vue?vue&type=style&index=0&id=ff0005ee&scoped=true&lang=css"
import "./ProjectOverview.vue?vue&type=style&index=1&id=ff0005ee&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0005ee"]])

export default __exports__